var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 337,
    viewBox: "0 0 327 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.999634,
    y: 6,
    width: 325,
    height: 325,
    rx: 162.5,
    stroke: "#FFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.167 331C158.167 333.946 160.554 336.333 163.5 336.333C166.445 336.333 168.833 333.946 168.833 331C168.833 328.054 166.445 325.667 163.5 325.667C160.554 325.667 158.167 328.054 158.167 331ZM158.167 6C158.167 8.94552 160.554 11.3333 163.5 11.3333C166.445 11.3333 168.833 8.94552 168.833 6C168.833 3.05448 166.445 0.666667 163.5 0.666667C160.554 0.666667 158.167 3.05448 158.167 6ZM325 167.5C325 257.254 253.238 330 163.5 330V332C254.359 332 327 258.343 327 167.5H325ZM1.99988 167.5C1.99988 77.7618 73.7455 7 163.5 7V5C72.6571 5 -0.00012207 76.6411 -0.00012207 167.5H1.99988Z",
    fill: "#F20F10"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_76_15",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 30,
    width: 278,
    height: 277
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 168.5C24.9999 92.0086 87.0084 30 163.5 30C239.991 30 302 92.0086 302 168.5C302 244.991 239.991 307 163.5 307C87.0084 307 24.9999 244.991 24.9999 168.5Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_76_15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38.0001,
    y: 25,
    width: 428,
    height: 285,
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRed);
export default __webpack_public_path__ + "static/media/circleRed.fac163c8a7b1539ac1eb3055d9c3fd85.svg";
export { ForwardRef as ReactComponent };